/* fetch.js */

import axiosInstance from "../axiosConfig.js";
import axiosFileInstance from "../axiosFileConfig.js";
import axiosIPFSInstance from "../axiosIPFSConfig.js";

// DPP API - Créer un produit
export const createProduct = async (productData) => {
  try {
    const response = await axiosInstance.post("/dpp/products/create", productData);
    console.log('=== productData === fetch.js === key: 478495 ===');
    console.dir(productData, { depth: null, colors: true })
    console.log('=================================');
    return {
      success: true,
      status: response.status,
      data: response.data,
      productData,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 382876
    };
  }
};

// DPP API - Récupérer la liste de tous les produits
export const fetchProducts = async () => {
  try {
    const response = await axiosInstance.get("/dpp/products");

    return {
      success: true,
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 215969,
    };
  }
};

// DPP API - Récupérer les informations d'un produit spécifique
export const fetchProduct = async (productId) => {
  try {
    const response = await axiosInstance.get(`/dpp/products/${productId}`);

    return {
      success: true,
      status: response.status,
      data: response.data,
      productId,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 419018,
    };
  }
};

// DPP API - Suivre un événement du cycle de vie d'un produit
export const trackProductLifecycle = async (productId, lifecycleData) => {
  console.log('=== lifecycleData === fetch.js === key: 648451 ===');
  console.dir(lifecycleData, { depth: null, colors: true })
  console.log('=================================');
  const sentData = { productId, eventType: lifecycleData.eventType, eventData:{...lifecycleData},timestamp: new Date().toISOString() };
  console.log('=== sentData === fetch.js === key: 169877 ===');
  console.dir(sentData, { depth: null, colors: true })
  console.log('=================================');
  try {
    const response = await axiosInstance.post(
      `/dpp/products/${productId}/lifecycle`,
      sentData
    );

    return {
      success: true,
      status: response.status,
      data: response.data,
      lifecycleData,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 618381,
    };
  }
};

// DPP API - Récupérer les événements du cycle de vie pour un produit
export const fetchProductLifecycle = async (productId) => {
  const url = `/dpp/products/${productId}/lifecycle`;
  console.log('=== url === fetch.js === key: 452811 ===');
  console.dir(url, { depth: null, colors: true })
  console.log('=================================');
  try {
    const response = await axiosInstance.get(url);

    console.log('=== response === fetch.js === key: 670922 ===');
    console.dir(response, { depth: null, colors: true })
    console.log('=================================');

    return {
      success: true,
      status: response.status,
      data: response.data,
      productId,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 250558,
    };
  }
};

/**
 * Fin de l'API DPP
 */

// Notarization API - Submit a document to be notarized
export const notarizeDocument = async (documentData) => {
  console.log("=== documentData === fetch.js === key: 220388 ===");
  console.dir(documentData, { depth: null, colors: true });
  console.log("=================================");
  try {
    const response = await axiosFileInstance.post(
      "/notarization/documents/create",
      documentData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return {
      success: true,
      status: response.status,
      data: response.data,
      documentData,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 580082,
    };
  }
};

// Notarization API - Get a list of all notarized documents
export const fetchNotarizedDocuments = async () => {
  try {
    const response = await axiosInstance.get("/notarization/documents");

    return {
      success: true,
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 513353,
    };
  }
};

// Notarization API - Get metadata of a specific document by ID
export const fetchDocumentMetadata = async (docId) => {
  try {
    const response = await axiosInstance.get(
      `/notarization/documents/${docId}`
    );

    return {
      success: true,
      status: response.status,
      data: response.data,
      docId,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 284672,
    };
  }
};

// Notarization API - Download a document by its ID
export const downloadNotarizedDocument = async (docId) => {
  try {
    const response = await axiosIPFSInstance.get(`/${docId}`, {
      responseType: "blob", // Important for downloading files
    });

    return {
      success: true,
      status: response.status,
      data: response.data,
      headers: response.headers,
      docId,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 570946,
    };
  }
};

// Notarization API - Track changes to a notarized document
export const trackDocumentChanges = async (docId, changeData) => {
  console.log("=== changeData === fetch.js === key: 656409 ===");
  console.dir(docId, { depth: null, colors: true });
  console.dir(changeData, { depth: null, colors: true });
  changeData.forEach((change) => {
    console.dir(change, { depth: null, colors: true });
  });
  console.log("=================================");
  try {
    const response = await axiosFileInstance.post(
      `/notarization/documents/${docId}/changes`,
      changeData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return {
      success: true,
      status: response.status,
      data: response.data,
      changeData,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 327235,
    };
  }
};

// Notarization API - Get the history of changes for a specific document
export const fetchDocumentChanges = async (docId) => {
  try {
    const response = await axiosInstance.get(
      `/notarization/documents/${docId}/changes`
    );

    return {
      success: true,
      status: response.status,
      data: response.data,
      docId,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 763072,
    };
  }
};

/**
 * End notarization api
 */

export const fetchEsgData = async (reportId) => {
  try {
    const response = await axiosInstance.get(
      `/esg-reporting/reports/${reportId}`
    );
    return {
      success: true,
      status: response.status,
      data: response.data,
      reportId,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 518358,
    };
  }
};

export const esgReportCreate = async (reportData) => {
  try {
    const response = await axiosFileInstance.post(
      "/esg-reporting/reports/create",
      reportData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return {
      success: true,
      status: response.status,
      data: response.data,
      reportData,
    };

    // Redirigez vers l'étape suivante après succès
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 637505,
    };
  }
};

export const createLot = async (newLot) => {
  console.log("=== newLot === fetch.js === key: 747417 ===");
  console.dir(newLot, { depth: null, colors: true });
  console.log("=================================");
  try {
    const resp = await axiosInstance.post("/supply-chain/lots/create", newLot);

    return {
      success: true,
      status: resp.status,
      data: resp.data,
      newLot,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 856383,
    };
  }
};

export const trackLotEvent = async (eventData = {}) => {
  console.log("=== eventData === fetch.js === key: 757973 ===");
  console.dir(eventData, { depth: null, colors: true });
  console.log("=================================");
  if (!eventData.lotId) {
    return {
      success: false,
      error: "lotId is required",
      errorKey: 907648,
    };
  }

  try {
    const resp = await axiosInstance.post(
      `/supply-chain/lots/${eventData.lotId}/events`,
      eventData
    );
    return {
      success: true,
      status: resp.status,
      data: resp.data,
      eventData,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 456765,
    };
  }
};

export const fetchLotEvents = async (lotId) => {
  try {
    const response = await axiosInstance.get(
      `/supply-chain/lots/${lotId}/events`
    );
    return {
      success: true,
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 563241,
    };
  }
};

export const fetchLot = async (lotId) => {
  try {
    const response = await axiosInstance.get(`/supply-chain/lots/${lotId}`);
    return {
      success: true,
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      errorKey: 563241,
    };
  }
};
